<template>
  <div id="OZViewer">
    <div id="data-app">
    
    </div>
    <router-view />
    <!--<div id="OZViewer">
        
    </div>-->
  </div>
</template>
<style lang="scss" scoped>
    #OZViewer{
      height:100%;
      overflow-y: auto;
    }
</style>
<script>
export default {
  name: 'OZViewer',
  data() {
    return {
      // v-dialog API https://vuetifyjs.com/en/api/v-dialog/
        OZ_VIEWER_ID: 'OZViewer',
        // OZ_SERVLET_PATH: 'http://dev.ozreport.yongmalogis.co.kr/oz80/server/',
        // OZ_VIEWER_PATH:'http://dev.ozreport.yongmalogis.co.kr/oz80/ozhviewer/',
        OZ_SERVLET_PATH: './oz80/server/',
        OZ_VIEWER_PATH:'./oz80/ozhviewer/',
        params: [],
        fileName: ''
    }
  },
  methods: {
    startOZViewer() {
        window['SetOZParamters_'+this.OZ_VIEWER_ID] = this.setOZParamters;
        window.start_ozjs(this.OZ_VIEWER_ID, this.OZ_VIEWER_PATH);
    },
    setOZParamters() {
        let oz = document.getElementById(this.OZ_VIEWER_ID)
        oz.innerHTML = ''
        oz.sendToActionScript('connection.servlet', this.OZ_SERVLET_PATH)

        if(this.fileName.length > 1){
          oz.sendToActionScript("viewer.childcount",""+(this.fileName.length-1)); // 멀티보고서의 child 개수 (전체개수-1) - 2개 ozr호출이면 1 입력
          oz.sendToActionScript("viewer.focus_doc_index","0"); // 처음 보여지는 보고서 번호(0부터 시작)
          oz.sendToActionScript("viewer.showtree","false"); // 트리창 표시
          oz.sendToActionScript("print.alldocument","true"); // 멀티 보고서 한번에 인쇄
          oz.sendToActionScript("global.concatpage","true"); // 페이지 연달아 나오게 하려면 true
          oz.sendToActionScript("global.inheritparameter","true"); // 첫번째 보고서의 파라미터 값을 상속 받음
        }
        oz.sendToActionScript('connection.servlet','/oz80/server');

        for(var i=0; i<this.fileName.length; i++){
          var tmpArg = this.params[i]
          var count = Object.keys(tmpArg).length;          
          var strConnect = "connection"
          
          if(i > 0){
            strConnect = "child"+i+".connection"
          }
          
          // alert("fileArray = " + fileArray[i] + '/' + "strConnect = " + strConnect);          
          oz.sendToActionScript(strConnect + '.reportname','YMCIMS/'+ this.fileName[i] + '.ozr')  //JSON 샘플
          oz.sendToActionScript(strConnect + '.pcount', ''+count);
          
          var idx = 1;
          for(var arg in tmpArg){
        //		alert("arg : " + arg + " / " + tmpArg[arg] );            
            var tmpStr = arg+'='+tmpArg[arg]
            oz.sendToActionScript(strConnect + '.args'+idx, tmpStr); 
            idx++;
          }	
        }

        /* 실제 사용 하던 oz
        let oz = document.getElementById(this.OZ_VIEWER_ID)
        oz.innerHTML = ''
        oz.sendToActionScript('connection.servlet', this.OZ_SERVLET_PATH)        
        oz.sendToActionScript('connection.reportname','/YMCIMS/' + this.fileName[0] + '.ozr')
        oz.sendToActionScript('connection.pcount', '1')        
        oz.sendToActionScript('odi.odinames', this.fileName[0])
        oz.sendToActionScript('odi.' + this.fileName[0] + '.pcount', this.params.length)
        for (let i=0; i<this.params.length; i++) {
          let tmpStr = ""
          for(let obj in this.params[i]){
            
            tmpStr = obj + "=" + this.setOzArrayToString(this.params[i][obj])
            // console.log(tmpStr) 
          }
          //console.log('odi.' + this.fileName + '.args'+(i+1)) 
          oz.sendToActionScript('odi.' + this.fileName + '.args'+(i+1),  tmpStr )
        }*/
        
        /* 테스트 필요 시 확인
        oz.sendToActionScript('connection.reportname','/YMWSM/custReport.ozr')
        oz.sendToActionScript('connection.pcount', '1')
        
        oz.sendToActionScript('odi.odinames','custReport')

        oz.sendToActionScript('odi.custReport.pcount','2')
        oz.sendToActionScript('odi.custReport.args1',"ordSeq='12'")
        oz.sendToActionScript('odi.custReport.args2',"custCd='116879'")
        */

        // oz.sendToActionScript('connection.reportname','/jsonSample.ozr')
        // oz.sendToActionScript('connection.pcount', '1')
        // oz.sendToActionScript('connection.args1', 'jsondata={ "Category": [{"CategoryID": 1, "CategoryName": "음료", "Description": "청량음료, 커피, 홍차, 맥주"},{"CategoryID": 2, "CategoryName": "조미료", "Description": "감미료, 향신료, 양념, 스프레드"},],"Product": [{"ProductID": 75, "ProductName": "알파인 맥주", "CategoryID": 1, "QuantityPerUnit": "24 - 0.5 l bottles", "UnitPrice": 24000.0000, "UnitsInStock":125},{"ProductID": 39, "ProductName": "OK 바닐라 셰이크", "CategoryID": 1, "QuantityPerUnit": "750 cc per bottle", "UnitPrice": 28000.0000, "UnitsInStock":69},{"ProductID": 34, "ProductName": "태일 라이트 맥주", "CategoryID": 1, "QuantityPerUnit": "24 - 12 oz bottles", "UnitPrice": 34000.0000, "UnitsInStock":111},{"ProductID": 65, "ProductName": "루이지애나 특산 후추", "CategoryID": 2, "QuantityPerUnit": "32 - 8 oz bottles", "UnitPrice": 21000.0000, "UnitsInStock":76},{"ProductID": 61, "ProductName": "사계절 핫 소스", "CategoryID": 2, "QuantityPerUnit": "24 - 500 ml bottles", "UnitPrice": 28000.0000, "UnitsInStock":111},{"ProductID": 6, "ProductName": "대양 특선 블루베리 잼", "CategoryID": 2, "QuantityPerUnit": "12 - 8 oz jars", "UnitPrice": 25000.0000, "UnitsInStock":120},] }')

        //ODI 연결 샘플
        //oz.sendToActionScript('odi.odinames','car');
        //oz.sendToActionScript('odi.car.pcount','3');
        //oz.sendToActionScript('odi.car.args1','maker=현대자동차');
        //oz.sendToActionScript('odi.car.args2','fromdd=20200813');
        //oz.sendToActionScript('odi.car.args3','todd=20210817');        
        return true;
    },
    initOzExecution(obj){
      // console.log(obj)
      this.setParamsValue(obj)
      this.startOZViewer()
    },
    setParamsValue(obj){
      // console.log('setParamsValue')
      this.fileName = obj.fileName
      this.params = obj.params
      // console.log('this.params = ' + this.params.length)
    },
    setOzArrayToString(val){
      var strArray = val.split(',')
      var tmpStr = ''
      for (var i=0; i<strArray.length; i++) {
        if (i !== 0) {
          tmpStr += ','
        }
        tmpStr += ("'" + strArray[i] + "'")
      }
      return tmpStr
    }
  },
  watch: {
  },
  computed: {
    
  },
  mounted() {
    // this.startOZViewer()
  }
}
</script>